/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { gameTrackerPublicControllerDeleteGamePbp } from '../fn/game-tracker-public/game-tracker-public-controller-delete-game-pbp';
import { GameTrackerPublicControllerDeleteGamePbp$Params } from '../fn/game-tracker-public/game-tracker-public-controller-delete-game-pbp';
import { gameTrackerPublicControllerDeleteGameUpdateImportant } from '../fn/game-tracker-public/game-tracker-public-controller-delete-game-update-important';
import { GameTrackerPublicControllerDeleteGameUpdateImportant$Params } from '../fn/game-tracker-public/game-tracker-public-controller-delete-game-update-important';
import { gameTrackerPublicControllerGetGameInfo } from '../fn/game-tracker-public/game-tracker-public-controller-get-game-info';
import { GameTrackerPublicControllerGetGameInfo$Params } from '../fn/game-tracker-public/game-tracker-public-controller-get-game-info';
import { gameTrackerPublicControllerGetGamePbp } from '../fn/game-tracker-public/game-tracker-public-controller-get-game-pbp';
import { GameTrackerPublicControllerGetGamePbp$Params } from '../fn/game-tracker-public/game-tracker-public-controller-get-game-pbp';
import { gameTrackerPublicControllerGetGamePbpById } from '../fn/game-tracker-public/game-tracker-public-controller-get-game-pbp-by-id';
import { GameTrackerPublicControllerGetGamePbpById$Params } from '../fn/game-tracker-public/game-tracker-public-controller-get-game-pbp-by-id';
import { PlayByPlayModelDto } from '../models/play-by-play-model-dto';
import { PublicGameInfoModelDto } from '../models/public-game-info-model-dto';
import { PublicGamePbpModelDto } from '../models/public-game-pbp-model-dto';

@Injectable({ providedIn: 'root' })
export class GameTrackerPublicService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `gameTrackerPublicControllerGetGameInfo()` */
  static readonly GameTrackerPublicControllerGetGameInfoPath = '/game-tracker-public/user/{userUuid}/games/{localId}/{accessHash}/info';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gameTrackerPublicControllerGetGameInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  gameTrackerPublicControllerGetGameInfo$Response(params: GameTrackerPublicControllerGetGameInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<PublicGameInfoModelDto>> {
    return gameTrackerPublicControllerGetGameInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `gameTrackerPublicControllerGetGameInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  gameTrackerPublicControllerGetGameInfo(params: GameTrackerPublicControllerGetGameInfo$Params, context?: HttpContext): Observable<PublicGameInfoModelDto> {
    return this.gameTrackerPublicControllerGetGameInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<PublicGameInfoModelDto>): PublicGameInfoModelDto => r.body)
    );
  }

  /** Path part for operation `gameTrackerPublicControllerGetGamePbp()` */
  static readonly GameTrackerPublicControllerGetGamePbpPath = '/game-tracker-public/user/{userUuid}/games/{localId}/{accessHash}/pbp';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gameTrackerPublicControllerGetGamePbp()` instead.
   *
   * This method doesn't expect any request body.
   */
  gameTrackerPublicControllerGetGamePbp$Response(params: GameTrackerPublicControllerGetGamePbp$Params, context?: HttpContext): Observable<StrictHttpResponse<PublicGamePbpModelDto>> {
    return gameTrackerPublicControllerGetGamePbp(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `gameTrackerPublicControllerGetGamePbp$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  gameTrackerPublicControllerGetGamePbp(params: GameTrackerPublicControllerGetGamePbp$Params, context?: HttpContext): Observable<PublicGamePbpModelDto> {
    return this.gameTrackerPublicControllerGetGamePbp$Response(params, context).pipe(
      map((r: StrictHttpResponse<PublicGamePbpModelDto>): PublicGamePbpModelDto => r.body)
    );
  }

  /** Path part for operation `gameTrackerPublicControllerGetGamePbpById()` */
  static readonly GameTrackerPublicControllerGetGamePbpByIdPath = '/game-tracker-public/user/{userUuid}/games/{localId}/{accessHash}/pbp/{pbpUuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gameTrackerPublicControllerGetGamePbpById()` instead.
   *
   * This method doesn't expect any request body.
   */
  gameTrackerPublicControllerGetGamePbpById$Response(params: GameTrackerPublicControllerGetGamePbpById$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayByPlayModelDto>> {
    return gameTrackerPublicControllerGetGamePbpById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `gameTrackerPublicControllerGetGamePbpById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  gameTrackerPublicControllerGetGamePbpById(params: GameTrackerPublicControllerGetGamePbpById$Params, context?: HttpContext): Observable<PlayByPlayModelDto> {
    return this.gameTrackerPublicControllerGetGamePbpById$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayByPlayModelDto>): PlayByPlayModelDto => r.body)
    );
  }

  /** Path part for operation `gameTrackerPublicControllerDeleteGamePbp()` */
  static readonly GameTrackerPublicControllerDeleteGamePbpPath = '/game-tracker-public/user/{userUuid}/games/{localId}/{accessHash}/pbp/{pbpUuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gameTrackerPublicControllerDeleteGamePbp()` instead.
   *
   * This method doesn't expect any request body.
   */
  gameTrackerPublicControllerDeleteGamePbp$Response(params: GameTrackerPublicControllerDeleteGamePbp$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return gameTrackerPublicControllerDeleteGamePbp(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `gameTrackerPublicControllerDeleteGamePbp$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  gameTrackerPublicControllerDeleteGamePbp(params: GameTrackerPublicControllerDeleteGamePbp$Params, context?: HttpContext): Observable<void> {
    return this.gameTrackerPublicControllerDeleteGamePbp$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `gameTrackerPublicControllerDeleteGameUpdateImportant()` */
  static readonly GameTrackerPublicControllerDeleteGameUpdateImportantPath = '/game-tracker-public/user/{userUuid}/games/{localId}/{accessHash}/pbp/{pbpUuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gameTrackerPublicControllerDeleteGameUpdateImportant()` instead.
   *
   * This method doesn't expect any request body.
   */
  gameTrackerPublicControllerDeleteGameUpdateImportant$Response(params: GameTrackerPublicControllerDeleteGameUpdateImportant$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return gameTrackerPublicControllerDeleteGameUpdateImportant(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `gameTrackerPublicControllerDeleteGameUpdateImportant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  gameTrackerPublicControllerDeleteGameUpdateImportant(params: GameTrackerPublicControllerDeleteGameUpdateImportant$Params, context?: HttpContext): Observable<void> {
    return this.gameTrackerPublicControllerDeleteGameUpdateImportant$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
